// AdminEventsPage.js
import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonImg,
    IonIcon,
    IonLoading, useIonAlert,
} from '@ionic/react';
import {
    chevronBack,
    chevronForward,
    trash, eye, pencil, addOutline, downloadOutline,
    imagesOutline, layersOutline, cashOutline // NEW: Gallery icons
} from 'ionicons/icons';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import useStore from "../../zustand/useStore";
import {
    actionToDeleteEventPostData,
    actionToGetEventsByFilter
} from "../../apiHelpers/CommonAction";
import AddEventModal from "../../components/AddEventsModal";
import moment from "moment-timezone";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import EventDetailModal from "../../components/EventDetailModal";
import EventGalleryModal from "../../components/EventGalleryModal";
import EventComboModal from "../../components/EventComboModal";
import EventTransactionListModal from "../../components/EventTransactionListModal"; // NEW

const ITEMS_PER_PAGE = 10;

const AdminEventsPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [addEventModalSheet, setAddEventModalSheet] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [eventFilterType, setEventFilterType] = useState('all');
    const [isDetailOpen,setIsDetailOpen] = useState(false)
    const { eventsDataState } = useStore();
    const { eventsData, loading, totalCount } = eventsDataState;
    const [eventDetailData, setEventDetailData] = useState(null);
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);
    const [presentAlert] = useIonAlert();
    const [dataForEditing, setDataForEditing] = useState(null);
    const [galleryModalOpen, setGalleryModalOpen] = useState(false);
    const [galleryEventId, setGalleryEventId] = useState(null);
    const [comboModalOpen, setComboModalOpen] = useState(false);
    const [comboEventId, setComboEventId] = useState(null);
    const [isTransactionListOpen, setIsTransactionListOpen] = useState(false);
    const [transactionsDataList, setTransactionsDataList] = useState(null);

    const openTransactionListModal = (data)=>{
        setTransactionsDataList(data);
        setIsTransactionListOpen(true);
    }

    const closeTransactionListModal = ()=>{
        setTransactionsDataList(null);
        setIsTransactionListOpen(false);
    }

    const openComboManager = (eventId) => {
        setComboEventId(eventId);
        setComboModalOpen(true);
    };

    const callFunctionToDeletedata = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteEventPostData(id)
                    }},
            ],
        });
    }

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        let all_events = false;
        let is_past_events = false;
        if(eventFilterType === 'past'){
            is_past_events = true;
        }else if(eventFilterType === 'upcoming'){
            is_past_events = false;
        }else{
            all_events = true;
        }
        actionToGetEventsByFilter(false, { offset: newOffset,is_past_events,all_events });
    }, [eventFilterType]);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const openEventDetailPanel = (eventDetail) =>{
        setEventDetailData(eventDetail);
        setIsDetailOpen(true);
    }
    const callFunctionToSetEditData = (data) => {
        setAddEventModalSheet(true);
        setDataForEditing(data);
    }

    const openGalleryManager = (eventId) => {
        setGalleryEventId(eventId);
        setGalleryModalOpen(true);
    };

    const downloadExcel = () => {
        const formattedData = eventsData.map(item => ({
            ID: item.id,
            Title: item.title,
            Topic: item.topic,
            Description: item.description,
            Venue: item.venue,
            // NOTE: if you've removed single price, you can adapt export or add dedicated columns
            Price_CA: item.price_for_ca,
            Price_Member: item.price_for_member,
            Price_Other: item.price_for_other,
            DateTime: item.event_date_time,
            Location: item.location,
            PDF: item.pdf_url,
            CreatedAt: item.created_at,
            CreatedBy: item.created_by,
        }));
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Events");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "events.xlsx");
    };



    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <div className={"d-flex ion-align-items-center w-full"}>
                            <h2 className="newsletter-heading">Events</h2>

                            <div className={"d-flex newsletter-heading_right ion-align-items-center ml-auto"}>
                                <IonIcon
                                    className="add_news_icon addnews-btn job-portal"
                                    onClick={() => setAddEventModalSheet(true)}
                                    icon={addOutline}
                                />
                                {eventsData?.length > 0 ?(
                                    <button className="download-button" onClick={() => downloadExcel()}>
                                        <IonIcon size={1} icon={downloadOutline}  />
                                        <span>Download</span>
                                    </button>
                                ):""}
                                <div className="admin-employee-filter admin_datatable_filter">
                                    <select
                                        className={"pl-2"}
                                        value={eventFilterType}
                                        onChange={(e) => setEventFilterType(e.target.value)}>
                                        <option value={'all'}>All</option>
                                        <option value={'upcoming'}>Upcoming</option>
                                        <option value={'past'}>Past</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table event-datatable">
                            <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Date & Time</th>
                                <th>Location</th>
                                <th>Combos</th>
                                <th>Gallery</th>
                                <th>Transactions</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(loading) ?
                                <>
                                    <tr><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td></tr>
                                    <tr><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td></tr>
                                    <tr><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td></tr>
                                    <tr><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td><td><FacebookLoader type={"facebookStyle"} item={1}/></td></tr>
                                </>
                                :(eventsData?.length > 0) ? (
                                    eventsData.map((item) => (
                                        <tr key={item.id}>
                                            <td><IonImg src={item.image_url} className="newsletter-img" /></td>
                                            <td>{item.title}</td>
                                            <td>{moment(item.event_date_time).format('dddd, Do MMMM, YYYY').toUpperCase()}</td>
                                            <td>{item.location}</td>
                                            <td className="combos_cell">
                                                <button
                                                    type="button"
                                                    className="combos_btn"
                                                    onClick={() => openComboManager(item.id)}
                                                    title="Manage Combos"
                                                >
                                                    <IonIcon icon={layersOutline} />
                                                </button>
                                            </td>
                                            {/* NEW: Gallery column with count & button */}
                                            <td className="gallery_cell">
                                                <button
                                                    type="button"
                                                    className="gallery_btn"
                                                    onClick={() => openGalleryManager(item.id)}
                                                    title="Manage Gallery"
                                                >
                                                    <IonIcon icon={imagesOutline} />
                                                </button>
                                            </td>

                                            <td className="gallery_cell">
                                                {(item.member_registrations?.length) ?
                                                <button
                                                    type="button"
                                                    className="gallery_btn"
                                                    onClick={() => openTransactionListModal(item.member_registrations)}
                                                    title="Member Transaction"
                                                >
                                                    <IonIcon icon={cashOutline} />
                                                </button>
                                                    :'No Data'
                                                }
                                            </td>

                                            <td className={"action_td"}>
                                                <IonIcon icon={eye} onClick={()=>openEventDetailPanel(item)} className={"admin_delete_button_icon eye_icon"}/>
                                                <IonIcon icon={pencil} onClick={()=>callFunctionToSetEditData(item)} className={"admin_delete_button_icon pencil_icon"}/>
                                                <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon"}/>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center', padding: '1rem' }}>
                                            No events found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button type="button" className="pagination_button" disabled={currentPage === 1} onClick={handlePrev}>
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">Page {currentPage} of {pageCount}</span>
                        <button type="button" className="pagination_button" disabled={currentPage === pageCount} onClick={handleNext}>
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>

            {/* Add Event Modal */}
            {(addEventModalSheet) ?
            <AddEventModal
                isOpen={addEventModalSheet}
                onClose={() => { setAddEventModalSheet(false); setDataForEditing(null); }}
                dataForEditing={dataForEditing}
                setIsLoading={setIsLoading}
            />:''
            }

            {/* Gallery Manager Modal */}
            {(galleryModalOpen) ?
            <EventGalleryModal
                isOpen={galleryModalOpen}
                eventId={galleryEventId}
                onClose={() => setGalleryModalOpen(false)}
            />:''
            }

            {/* Global Loader */}
            <IonLoading isOpen={isLoading} className="loading_loader_spinner_container" message="Please Wait..." />

            <EventDetailModal
                isOpen={isDetailOpen}
                eventDetailData={eventDetailData}
                onDidDismiss={() => { setEventDetailData(null); setIsDetailOpen(false); }}
            />

            <EventComboModal
                isOpen={comboModalOpen}
                eventId={comboEventId}
                onClose={() => setComboModalOpen(false)}
            />

            {(isTransactionListOpen && transactionsDataList?.length) ?
            <EventTransactionListModal
                isOpen={isTransactionListOpen}
                onDidDismiss={() => closeTransactionListModal(false)}
                title="Event Transactions"
                transactions={transactionsDataList}
            />:''
            }
        </IonPage>
    );
};

export default AdminEventsPage;
